export interface Manga {
  id: string;
  title: string;
  category: string; // category id
  status: "连载中" | "已完结";
  isFree: boolean;
  isNew: boolean;
  tags: string[];
  author: string;
  intro: string;
  chapters: number;
  rating: number;
  popularity: number;
  cover: string;
  updateInfo: string;
  hot: number;
}

export const mangaList: Manga[] = [
  {
    id: "summer-confession",
    title: "夏日的告白信",
    category: "love",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["校园", "甜宠", "纯爱"],
    author: "林小满",
    intro: "一封迟到三年的情书，把两个青梅竹马重新拉回了彼此的世界。樱花盛开的季节，少年鼓起勇气写下那句藏在心底多年的告白。",
    chapters: 126,
    rating: 9.4,
    popularity: 98620,
    cover: "https://readdy.ai/api/search-image?query=romantic%20anime%20manga%20cover%20portrait%20of%20young%20couple%20under%20cherry%20blossom%20rain%2C%20warm%20coral%20and%20soft%20pink%20palette%2C%20sweet%20youthful%20energy%2C%20clean%20vector%20style%2C%20soft%20lighting%2C%20high%20quality%20illustration&width=600&height=800&seq=manga-summer-confession&orientation=portrait",
    updateInfo: "第126话 · 3天前更新",
    hot: 920,
  },
  {
    id: "moonlight-promise",
    title: "月光下的约定",
    category: "love",
    status: "连载中",
    isFree: false,
    isNew: false,
    tags: ["都市", "治愈", "初恋"],
    author: "白鹿鸣",
    intro: "城市霓虹之下，两个曾在月光下许下约定的人，多年后在深夜的咖啡店里再度重逢。过去与现在交织，他们能否兑现那份温柔的承诺。",
    chapters: 98,
    rating: 9.1,
    popularity: 74580,
    cover: "https://readdy.ai/api/search-image?query=romantic%20anime%20manga%20cover%20portrait%20of%20couple%20under%20moonlight%20with%20city%20night%20bokeh%2C%20teal%20and%20warm%20amber%20palette%2C%20dreamy%20moody%20lighting%2C%20clean%20vector%20illustration&width=600&height=800&seq=manga-moonlight&orientation=portrait",
    updateInfo: "第98话 · 1周前更新",
    hot: 680,
  },
  {
    id: "heart-signal",
    title: "心动信号",
    category: "love",
    status: "已完结",
    isFree: true,
    isNew: false,
    tags: ["校园", "欢喜冤家", "搞笑"],
    author: "糖糖圈",
    intro: "天雷地火的欢喜冤家，从互相看不顺眼到一步步沦陷。校园电台里流动的心动信号，连旁人都替他们着急。",
    chapters: 156,
    rating: 9.3,
    popularity: 112400,
    cover: "https://readdy.ai/api/search-image?query=cheerful%20romantic%20anime%20manga%20cover%20portrait%20of%20school%20radio%20hosts%20with%20heart%20speech%20bubbles%2C%20bright%20peach%20and%20cream%20palette%2C%20playful%20energetic%20illustration&width=600&height=800&seq=manga-heart-signal&orientation=portrait",
    updateInfo: "已完结 · 全156话",
    hot: 780,
  },
  {
    id: "young-warrior",
    title: "少年武者",
    category: "shounen",
    status: "连载中",
    isFree: false,
    isNew: true,
    tags: ["战斗", "成长", "武道"],
    author: "绝尘刀",
    intro: "出身平凡的少年踏上武道之路，在一次次生死对决中淬炼自我。当守护之物被夺走，他要用拳头打出一条属于自己的成王之路。",
    chapters: 210,
    rating: 9.5,
    popularity: 158300,
    cover: "https://readdy.ai/api/search-image?query=epic%20shonen%20anime%20manga%20cover%20portrait%20of%20young%20martial%20artist%20in%20battle%20stance%20with%20fire%20aura%2C%20warm%20orange%20and%20red%20palette%2C%20dynamic%20powerful%20composition%2C%20dramatic%20lighting&width=600&height=800&seq=manga-young-warrior&orientation=portrait",
    updateInfo: "第210话 · 2天前更新",
    hot: 990,
  },
  {
    id: "comeback-road",
    title: "逆袭之路",
    category: "shounen",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["热血", "竞技", "团队"],
    author: "炽热之心",
    intro: "被淘汰的天才选手跌落谷底，却在一支草根队伍里找到重新站起来的理由。真正的强者，是跌倒后还能再战的逆袭者。",
    chapters: 168,
    rating: 9.2,
    popularity: 102600,
    cover: "https://readdy.ai/api/search-image?query=inspiring%20sports%20anime%20manga%20cover%20portrait%20of%20determined%20athlete%20with%20sunset%20arena%20background%2C%20coral%20and%20teal%20palette%2C%20motivational%20dynamic%20composition%2C%20clean%20illustration&width=600&height=800&seq=manga-comeback&orientation=portrait",
    updateInfo: "第168话 · 5天前更新",
    hot: 840,
  },
  {
    id: "flame-martial",
    title: "烈焰武道",
    category: "shounen",
    status: "已完结",
    isFree: false,
    isNew: false,
    tags: ["战斗", "古武", "友情"],
    author: "焚天",
    intro: "上古烈焰心法重现江湖，少年背负家族遗志踏上寻回至强武道的旅途。兄弟并肩，热血燃烧，写给青春的一封战书。",
    chapters: 245,
    rating: 9.0,
    popularity: 133700,
    cover: "https://readdy.ai/api/search-image?query=fierce%20wuxia%20anime%20manga%20cover%20portrait%20of%20warrior%20with%20blazing%20sword%20and%20embers%2C%20vermilion%20and%20dark%20grey%20palette%2C%20epic%20cinematic%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=manga-flame-martial&orientation=portrait",
    updateInfo: "已完结 · 全245话",
    hot: 720,
  },
  {
    id: "mist-detective",
    title: "迷雾侦探社",
    category: "suspense",
    status: "连载中",
    isFree: false,
    isNew: true,
    tags: ["推理", "探案", "悬疑"],
    author: "冷案手记",
    intro: "一间藏身于旧城区的小小侦探社，接手的却是一桩桩看似无解的案件。每个谜团背后，都藏着一段不为人知的过往。",
    chapters: 132,
    rating: 9.3,
    popularity: 89700,
    cover: "https://readdy.ai/api/search-image?query=mysterious%20anime%20manga%20cover%20portrait%20of%20detective%20in%20trench%20coat%20holding%20magnifying%20glass%20in%20foggy%20night%20alley%2C%20teal%20and%20deep%20green%20palette%2C%20moody%20suspenseful%20lighting&width=600&height=800&seq=manga-mist-detective&orientation=portrait",
    updateInfo: "第132话 · 3天前更新",
    hot: 860,
  },
  {
    id: "file-no-7",
    title: "第七号档案",
    category: "suspense",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["悬疑", "都市", "反转"],
    author: "雾里看花",
    intro: "代号第七号的机密档案离奇失踪，知情者接连失去记忆。主角必须在时间倒计时前，从支离破碎的线索里拼出真相。",
    chapters: 84,
    rating: 9.0,
    popularity: 76800,
    cover: "https://readdy.ai/api/search-image?query=conspiracy%20thriller%20anime%20manga%20cover%20portrait%20of%20figure%20unlocking%20vault%20file%20cabinet%20with%20redacted%20documents%2C%20dark%20teal%20and%20grey%20palette%2C%20tense%20noir%20lighting&width=600&height=800&seq=manga-file-no7&orientation=portrait",
    updateInfo: "第84话 · 1周前更新",
    hot: 700,
  },
  {
    id: "midnight-mystery",
    title: "深夜谜案",
    category: "suspense",
    status: "已完结",
    isFree: true,
    isNew: false,
    tags: ["悬疑", "推理", "犯罪"],
    author: "夜行者",
    intro: "每一桩发生在午夜的案件，都像被精心编排的舞台剧。刑警与神秘笔记主人之间，展开一场跨越十年的智力对决。",
    chapters: 190,
    rating: 9.2,
    popularity: 98500,
    cover: "https://readdy.ai/api/search-image?query=noir%20crime%20anime%20manga%20cover%20portrait%20of%20detective%20under%20streetlamp%20in%20midnight%20city%2C%20monochrome%20teal%20and%20warm%20amber%20light%2C%20moody%20atmospheric%20composition&width=600&height=800&seq=manga-midnight&orientation=portrait",
    updateInfo: "已完结 · 全190话",
    hot: 650,
  },
  {
    id: "cat-cafe",
    title: "猫咪咖啡馆",
    category: "healing",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["治愈", "萌宠", "日常"],
    author: "暖洋洋",
    intro: "在街角那家被猫咪占据的小咖啡馆里，每天都有带着心事而来的客人。一杯热饮，一只撒娇的猫，足以抚平所有的不安。",
    chapters: 78,
    rating: 9.5,
    popularity: 82600,
    cover: "https://readdy.ai/api/search-image?query=cozy%20healing%20anime%20manga%20cover%20portrait%20of%20cute%20cat%20sitting%20on%20cafe%20counter%20with%20coffee%20cup%2C%20cream%20and%20mint%20warm%20palette%2C%20soft%20gentle%20lighting%2C%20adorable%20illustration&width=600&height=800&seq=manga-cat-cafe&orientation=portrait",
    updateInfo: "第78话 · 2天前更新",
    hot: 880,
  },
  {
    id: "forest-snack",
    title: "森林里的点心铺",
    category: "healing",
    status: "连载中",
    isFree: false,
    isNew: true,
    tags: ["治愈", "奇幻", "美食"],
    author: "青团子",
    intro: "开在森林深处的神秘点心铺，只有心灵需要慰藉的人才能找到它。每一种甜点，都藏着治愈一段记忆的魔法。",
    chapters: 96,
    rating: 9.1,
    popularity: 71200,
    cover: "https://readdy.ai/api/search-image?query=whimsical%20healing%20anime%20manga%20cover%20portrait%20of%20forest%20bakery%20shop%20with%20pastries%20and%20fireflies%2C%20mint%20and%20peach%20palette%2C%20dreamy%20soft%20glow%2C%20charming%20illustration&width=600&height=800&seq=manga-forest-snack&orientation=portrait",
    updateInfo: "第96话 · 4天前更新",
    hot: 730,
  },
  {
    id: "gentle-time",
    title: "温柔时光",
    category: "healing",
    status: "已完结",
    isFree: true,
    isNew: false,
    tags: ["治愈", "亲情", "日常"],
    author: "慢镜头",
    intro: "记录祖孙三代在四季流转中的日常点滴。那些平凡温暖的瞬间，正是生活里最珍贵的温柔时光。",
    chapters: 112,
    rating: 9.2,
    popularity: 65900,
    cover: "https://readdy.ai/api/search-image?query=heartwarming%20healing%20anime%20manga%20cover%20portrait%20of%20grandmother%20and%20grandchild%20by%20sunlit%20window%20with%20seasonal%20leaves%2C%20warm%20cream%20and%20soft%20peach%20palette%2C%20tender%20nostalgic%20illustration&width=600&height=800&seq=manga-gentle-time&orientation=portrait",
    updateInfo: "已完结 · 全112话",
    hot: 620,
  },
  {
    id: "star-contract",
    title: "星辰契约",
    category: "fantasy",
    status: "连载中",
    isFree: false,
    isNew: true,
    tags: ["魔法", "异界", "冒险"],
    author: "星河拾贝",
    intro: "天穹之上群星坠落，少年与传说中的星灵缔结契约，踏上了守护这片星海的旅程。命运之轮就此转动。",
    chapters: 145,
    rating: 9.3,
    popularity: 121800,
    cover: "https://readdy.ai/api/search-image?query=epic%20fantasy%20anime%20manga%20cover%20portrait%20of%20youth%20with%20luminous%20star%20spirit%20above%20celestial%20sky%2C%20vibrant%20teal%20and%20peach%20gradient%2C%20magical%20glowing%20composition&width=600&height=800&seq=manga-star-contract&orientation=portrait",
    updateInfo: "第145话 · 1天前更新",
    hot: 930,
  },
  {
    id: "shanhai-journey",
    title: "山海幻游录",
    category: "fantasy",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["古风", "仙侠", "奇遇"],
    author: "青崖客",
    intro: "一部记录山海之间奇人异兽的仙侠游记。主角循着上古残卷，游历九洲四海，破解被尘封千年的天地之谜。",
    chapters: 118,
    rating: 9.0,
    popularity: 90200,
    cover: "https://readdy.ai/api/search-image?query=ancient%20xianxia%20anime%20manga%20cover%20portrait%20of%20wandering%20scholar%20with%20mythical%20beast%20over%20misty%20mountains%2C%20ink%20wash%20and%20vermilion%20palette%2C%20elegant%20eastern%20fantasy%20illustration&width=600&height=800&seq=manga-shanhai&orientation=portrait",
    updateInfo: "第118话 · 5天前更新",
    hot: 790,
  },
  {
    id: "otherworld-traveler",
    title: "异世界旅人",
    category: "fantasy",
    status: "已完结",
    isFree: false,
    isNew: false,
    tags: ["异世界", "冒险", "成长"],
    author: "晨光",
    intro: "普通青年意外坠入异世界，从手无缚鸡之力到一步步成长为独当一面的旅人，用脚步丈量这个陌生而辽阔的世界。",
    chapters: 178,
    rating: 9.1,
    popularity: 107500,
    cover: "https://readdy.ai/api/search-image?query=adventurous%20isekai%20anime%20manga%20cover%20portrait%20of%20traveler%20with%20backpack%20facing%20giant%20gate%20and%20strange%20landscape%2C%20coral%20and%20teal%20palette%2C%20vast%20epic%20composition&width=600&height=800&seq=manga-otherworld&orientation=portrait",
    updateInfo: "已完结 · 全178话",
    hot: 700,
  },
  {
    id: "rooftop-youth",
    title: "天台上的青春",
    category: "campus",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["校园", "友情", "成长"],
    author: "追风少年",
    intro: "放学后的天台，是少年们交换秘密的专属角落。关于梦想、友情和那些没说出口的心事，都留在了风里。",
    chapters: 92,
    rating: 9.0,
    popularity: 68800,
    cover: "https://readdy.ai/api/search-image?query=youthful%20school%20anime%20manga%20cover%20portrait%20of%20friends%20sitting%20on%20school%20rooftop%20watching%20sunset%2C%20warm%20peach%20and%20mint%20palette%2C%20nostalgic%20gentle%20composition&width=600&height=800&seq=manga-rooftop&orientation=portrait",
    updateInfo: "第92话 · 3天前更新",
    hot: 660,
  },
  {
    id: "club-story",
    title: "社团物语",
    category: "campus",
    status: "已完结",
    isFree: true,
    isNew: false,
    tags: ["校园", "搞笑", "社团"],
    author: "小剧场",
    intro: "一个濒临解散的冷门社团，一群性格迥异却意外合拍的伙伴。为了保住社团，他们开启了一段鸡飞狗跳的搞笑日常。",
    chapters: 134,
    rating: 8.9,
    popularity: 57800,
    cover: "https://readdy.ai/api/search-image?query=playful%20school%20club%20anime%20manga%20cover%20portrait%20of%20group%20of%20students%20with%20club%20sign%20and%20confetti%2C%20bright%20cream%20and%20coral%20palette%2C%20fun%20energetic%20illustration&width=600&height=800&seq=manga-club-story&orientation=portrait",
    updateInfo: "已完结 · 全134话",
    hot: 580,
  },
  {
    id: "sky-expedition",
    title: "苍穹远征",
    category: "adventure",
    status: "连载中",
    isFree: false,
    isNew: true,
    tags: ["冒险", "飞行", "热血"],
    author: "凌云志",
    intro: "在漂浮着巨型空岛的苍穹世界，一支远征队驾驶飞空艇冲破云层，向传说中的天空尽头发起挑战。",
    chapters: 103,
    rating: 9.1,
    popularity: 84300,
    cover: "https://readdy.ai/api/search-image?query=epic%20sky%20adventure%20anime%20manga%20cover%20portrait%20of%20airship%20sailing%20through%20clouds%20above%20floating%20islands%2C%20teal%20and%20warm%20gold%20palette%2C%20vast%20dynamic%20composition&width=600&height=800&seq=manga-sky-expedition&orientation=portrait",
    updateInfo: "第103话 · 2天前更新",
    hot: 810,
  },
  {
    id: "secret-realm",
    title: "秘境探索队",
    category: "adventure",
    status: "已完结",
    isFree: true,
    isNew: false,
    tags: ["冒险", "解谜", "秘境"],
    author: "地图师",
    intro: "深入无人踏足的原始秘境，探索队以勇气与智慧破解古老遗迹的谜题，每一扇石门背后都是全新的世界。",
    chapters: 152,
    rating: 9.0,
    popularity: 76700,
    cover: "https://readdy.ai/api/search-image?query=exploration%20anime%20manga%20cover%20portrait%20of%20expedition%20team%20with%20torch%20entering%20ancient%20stone%20temple%20in%20jungle%2C%20deep%20teal%20and%20amber%20palette%2C%20mysterious%20composition&width=600&height=800&seq=manga-secret-realm&orientation=portrait",
    updateInfo: "已完结 · 全152话",
    hot: 630,
  },
  {
    id: "slam-dunk-wind",
    title: "灌篮风云",
    category: "sports",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["篮球", "竞技", "热血"],
    author: "空中飞人",
    intro: "一支不被看好的高中篮球队，在县大赛上一次次创造奇迹。最后一秒的绝杀，献给所有热爱篮球的人。",
    chapters: 142,
    rating: 9.4,
    popularity: 118900,
    cover: "https://readdy.ai/api/search-image?query=explosive%20basketball%20anime%20manga%20cover%20portrait%20of%20player%20slam%20dunking%20with%20stadium%20spotlight%20crowd%2C%20coral%20and%20teal%20palette%2C%20high%20energy%20dynamic%20composition&width=600&height=800&seq=manga-slam-dunk&orientation=portrait",
    updateInfo: "第142话 · 1天前更新",
    hot: 910,
  },
  {
    id: "swift-football",
    title: "疾风足球队",
    category: "sports",
    status: "连载中",
    isFree: false,
    isNew: true,
    tags: ["足球", "团队", "青春"],
    author: "绿茵场",
    intro: "绿茵场上的少年们以足球为纽带，从街头野球到职业舞台，用一场场硬仗诠释速度与热血的青春。",
    chapters: 88,
    rating: 9.0,
    popularity: 69800,
    cover: "https://readdy.ai/api/search-image?query=dynamic%20football%20anime%20manga%20cover%20portrait%20of%20soccer%20player%20shooting%20with%20motion%20trails%20on%20green%20field%2C%20green%20and%20coral%20palette%2C%20sporty%20dynamic%20composition&width=600&height=800&seq=manga-swift-football&orientation=portrait",
    updateInfo: "第88话 · 4天前更新",
    hot: 670,
  },
  {
    id: "daily-comedy",
    title: "日常沙雕图鉴",
    category: "comedy",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["搞笑", "日常", "吐槽"],
    author: "皮一下",
    intro: "记录社畜与学生的沙雕日常，笑点密集到停不下来。看完只想说一句：这不就是我本人吗？",
    chapters: 76,
    rating: 9.1,
    popularity: 75900,
    cover: "https://readdy.ai/api/search-image?query=hilarious%20slice%20of%20life%20anime%20manga%20cover%20portrait%20of%20exaggerated%20cartoon%20office%20workers%20with%20funny%20expressions%2C%20bright%20peach%20and%20cream%20palette%2C%20playful%20comedy%20illustration&width=600&height=800&seq=manga-daily-comedy&orientation=portrait",
    updateInfo: "第76话 · 2天前更新",
    hot: 750,
  },
  {
    id: "sword-river",
    title: "剑影江湖录",
    category: "ancient",
    status: "连载中",
    isFree: true,
    isNew: true,
    tags: ["武侠", "江湖", "恩怨"],
    author: "仗剑行",
    intro: "一柄无名古剑，一段恩怨江湖。初出茅庐的少年剑客，在刀光剑影与儿女情长中，书写属于自己的侠客传说。",
    chapters: 129,
    rating: 9.2,
    popularity: 97400,
    cover: "https://readdy.ai/api/search-image?query=elegant%20wuxia%20anime%20manga%20cover%20portrait%20of%20young%20swordsman%20holding%20sword%20among%20maple%20leaves%20with%20ink%20mountains%2C%20vermilion%20and%20ink%20grey%20palette%2C%20refined%20chinese%20composition&width=600&height=800&seq=manga-sword-river&orientation=portrait",
    updateInfo: "第129话 · 3天前更新",
    hot: 830,
  },
];